var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"md:col-start-1 md:col-end-4 w-full h-96 md:h-120 xl:h-150 rounded"},_vm._l((_vm.markers),function(ref,key){
var icon = ref.icon;
var position = ref.position;
var title = ref.title;
var distance = ref.distance;
return _c('div',{key:key,ref:"marker",refInFor:true,attrs:{"data-title":title,"data-distance":distance,"data-icon":icon,"data-lat":position.lat,"data-lng":position.lng}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }